import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Link, Sparkles, Building } from 'lucide-react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

export const UserSetupSelection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl p-8 space-y-6">
        <div className="text-center space-y-2">
          <h1 className="text-2xl font-black text-gray-900 uppercase italic tracking-tighter">
            Getting Started
          </h1>
          <p className="text-sm text-gray-500 font-medium">How would you like to begin?</p>
        </div>

        <div className="space-y-4">
          <button
            onClick={() => navigate('/setup-link')}
            className="w-full flex items-center gap-4 bg-gray-900 text-white rounded-xl p-6 hover:bg-gray-800 transition-all active:scale-95"
          >
            <Link size={24} />
            <div className="text-left">
              <p className="font-bold">Join an Existing Team</p>
              <p className="text-xs text-gray-400">Link your account using a Tenant ID</p>
            </div>
          </button>

          <button
            onClick={() => navigate('/onboarding')}
            className="w-full flex items-center gap-4 bg-blue-600 text-white rounded-xl p-6 hover:bg-blue-700 transition-all active:scale-95"
          >
            <Building size={24} />
            <div className="text-left">
              <p className="font-bold">Create a New Business</p>
              <p className="text-xs text-blue-100">Set up a new TipValue AI instance</p>
            </div>
          </button>
        </div>

        <button 
          onClick={() => signOut(auth)} 
          className="w-full text-center text-gray-500 text-xs font-bold uppercase tracking-widest mt-4 hover:text-gray-900"
        >
          Sign Out
        </button>
      </div>
    </main>
  );
};
